module.exports = __webpack_public_path__ + "static/media/bakery_image2.d97d3a5a.png";